'use es6';

import { DEAL_PIPELINE_WATERFALL_RM_GATE, DEAL_PUSH_RATE_RM_GATE, IMPROVED_RECURRING_REVENUE_GATE, PIPELINE_SNAPSHOT_RM_GATE, QUOTA_ATTAINMENT_RM_GATE, DEAL_CHANGE_HISTORY_MIGRATION_V2_GATE } from '../constants/gates';
import { DEAL_CHANGE_HISTORY_CW_CONFIG, DEAL_PIPELINE_WATERFALL_CONFIG, DEAL_PUSH_RATE_CONFIG, PIPELINE_SNAPSHOT_CONFIG } from './inDevDealReplacements';
import { FORECAST_CATEGORY_CONFIG, QUOTA_ATTAINMENT_CONFIG, WEIGHTED_FORECAST_CATEGORY_CONFIG, WEIGHTED_PIPELINE_FORECAST_CONFIG } from './inDevQuotaAttainmentReplacements';

// Home to reports that are in development and should eventually live in ReALM

export const REPORT_KEY_TO_CONFIG = {
  // PIPELINE SNAPSHOTS
  pipelineSnapshots: PIPELINE_SNAPSHOT_CONFIG,
  // DEAL PUSH RATE
  dealPushAnalysis: DEAL_PUSH_RATE_CONFIG,
  // DEAL PIPELINE WATERFALL
  waterfall: DEAL_PIPELINE_WATERFALL_CONFIG,
  // DEAL CHANGE HISTORY CW
  changeHistoryDealList: DEAL_CHANGE_HISTORY_CW_CONFIG,
  // Weighted Forecast Category
  weightedPipelineForecast: WEIGHTED_PIPELINE_FORECAST_CONFIG,
  // Weighted Forecast Category
  manualForecast: WEIGHTED_FORECAST_CATEGORY_CONFIG,
  // Forecast Category
  manualForecastTotal: FORECAST_CATEGORY_CONFIG,
  // Quota Attainment
  quotaAttainment: QUOTA_ATTAINMENT_CONFIG
};

// We render these hard-coded reports if the user is ungated
export const REALM_REPORT_TO_IN_DEV_REPORT_GATE_CONFIG = {
  pipelineSnapshots: PIPELINE_SNAPSHOT_RM_GATE,
  dealPushAnalysis: DEAL_PUSH_RATE_RM_GATE,
  waterfall: DEAL_PIPELINE_WATERFALL_RM_GATE,
  closedWonRecurringRevenue: IMPROVED_RECURRING_REVENUE_GATE,
  openRecurringRevenue: IMPROVED_RECURRING_REVENUE_GATE,
  allClosedWonRevenue: IMPROVED_RECURRING_REVENUE_GATE,
  manualForecast: QUOTA_ATTAINMENT_RM_GATE,
  weightedPipelineForecast: QUOTA_ATTAINMENT_RM_GATE,
  manualForecastTotal: QUOTA_ATTAINMENT_RM_GATE,
  quotaAttainment: QUOTA_ATTAINMENT_RM_GATE
};

// We render these realm reports if the user is ungated
export const IN_DEV_REPORT_TO_REALM_REPORT_GATE_CONFIG = {
  changeHistoryDealList: DEAL_CHANGE_HISTORY_MIGRATION_V2_GATE
};